var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 36H6.5C4.248 36 2.648 35.018 1.676 33.668C0.920464 32.5932 0.510258 31.3137 0.5 30V6C0.5 4.4087 1.13214 2.88258 2.25736 1.75736C3.38258 0.632141 4.9087 0 6.5 0H26.5C28.0913 0 29.6174 0.632141 30.7426 1.75736C31.8679 2.88258 32.5 4.4087 32.5 6V16H38.5C39.0304 16 39.5391 16.2107 39.9142 16.5858C40.2893 16.9609 40.5 17.4696 40.5 18V30C40.5 30.986 40.22 32.422 39.324 33.668C38.35 35.02 36.75 36 34.5 36ZM36.5 22C36.5 21.4696 36.2893 20.9609 35.9142 20.5858C35.5391 20.2107 35.0304 20 34.5 20C33.9696 20 33.4609 20.2107 33.0858 20.5858C32.7107 20.9609 32.5 21.4696 32.5 22V30C32.5 30.5304 32.7107 31.0391 33.0858 31.4142C33.4609 31.7893 33.9696 32 34.5 32C35.0304 32 35.5391 31.7893 35.9142 31.4142C36.2893 31.0391 36.5 30.5304 36.5 30V22Z",
    fill: "#00AB55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.c927181d7a893cd751d088031bb7b219.svg";
export { ForwardRef as ReactComponent };